import { reactive } from "vue";

const STORAGE_KEY = "datacasting:view-as-business-client";

function normalizeClient(value) {
  return String(value || "").trim().toLowerCase();
}

function readStoredClient() {
  try {
    return normalizeClient(window.sessionStorage.getItem(STORAGE_KEY));
  } catch {
    return "";
  }
}

export const clientViewState = reactive({
  authorizedClients: [],
  selectedClient: readStoredClient(),
});

export function setAuthorizedClients(clients) {
  const raw = Array.isArray(clients)
    ? clients
    : clients?.business_clients || clients?.data || clients?.results || [];
  const normalized = [...new Set(raw
    .map((item) => {
      if (typeof item === "string") return item;
      return item?.business_client || item?.name || item?.client || "";
    })
    .map(normalizeClient)
    .filter(Boolean))]
    .sort((left, right) => left.localeCompare(right));

  clientViewState.authorizedClients = normalized;
  if (!normalized.includes(clientViewState.selectedClient)) {
    setClientView("");
  }
}

export function setClientView(client) {
  const normalized = normalizeClient(client);
  clientViewState.selectedClient = normalized;
  try {
    if (normalized) {
      window.sessionStorage.setItem(STORAGE_KEY, normalized);
    } else {
      window.sessionStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // sessionStorage pode estar indisponível em contextos restritos do navegador.
  }
}

export function clearClientView() {
  setClientView("");
}
